import { z } from 'zod'

export const schema = z.object({
  id: z.number(),
  attributes: z.object({
    publishedAt: z.string().nullable(),
    title: z.string().min(1),
    head: z.object({
      id: z.number(),
      title: z.string().min(1),
      description: z.string().min(1),
      image: z.object({
        data: z.object({
          id: z.number(),
          attributes: z.object({
            url: z.string().min(1),
          }),
        }),
      }),
    }),
    blocks: z.array(
      z.object({
        id: z.number(),
        __component: z.string().min(1),
        title: z.string().min(1),
        content: z.string().min(1),
        desktopImageRight: z.boolean(),
        image: z.object({
          data: z.object({
            id: z.number(),
            attributes: z.object({
              url: z.string().min(1),
            }),
          }),
        }),
        cta: z
          .object({
            id: z.number(),
            variant: z.enum([
              'solid',
              'link',
              'outline',
              'soft',
              'ghost',
              'concrete',
            ]),
            text: z.string().min(1),
            url: z.string().min(1),
          })
          .optional()
          .nullable(),
      }),
    ),
  }),
})

export type schemaType = z.infer<typeof schema>

export type returnType = ApiServerResponse<schemaType>
